import {ReachableAirportResponse} from "../services/AirportService";

/** One place per city/country; a direct airport takes precedence over stopovers. */
export function uniqueDestinationOptions(airports: ReachableAirportResponse[], selectedCodes: string[] = []) {
  const byCity = new Map<string, ReachableAirportResponse>();
  const selected = new Set(selectedCodes);
  const priority = (airport: ReachableAirportResponse) =>
    (airport.reachability === "oneStop" ? 2 : 0) + (selected.has(airport.iata) ? 0 : 1);
  airports.forEach(airport => {
    const city = airport.city.trim().toLowerCase();
    const key = city ? `${airport.country_code.toUpperCase()}:${city}` : airport.iata;
    const current = byCity.get(key);
    if (!current || priority(airport) < priority(current)) byCity.set(key, airport);
  });
  return Array.from(byCity.values());
}
